import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getOutstandingIncome } from '../services/api';

/**
 * Income that has been earned but not yet paid.
 *
 * The same shape as useMonthlyEntries minus the month arguments, because
 * receivables aren't month-scoped: an invoice raised in March is still
 * outstanding in July.
 *
 * @param {number} refreshKey Bumped by any mutation to re-sync.
 * @returns {{ entries: Object[], setEntries: Function, error: string }}
 */
export const useOutstandingIncome = (refreshKey) => {
  const { user } = useAuth();
  // See the note in useMonthlyEntries: keyed on the id so an auth token refresh
  // doesn't trigger a refetch.
  const userId = user?.id;
  const [entries, setEntries] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!userId) return undefined;
    let cancelled = false;

    getOutstandingIncome()
      .then((data) => {
        if (cancelled) return;
        setEntries(data);
        setError('');
      })
      .catch((caught) => {
        if (cancelled) return;
        console.error(caught);
        setError("Couldn't load outstanding income.");
      });

    return () => {
      cancelled = true;
    };
  }, [userId, refreshKey]);

  return { entries, setEntries, error };
};

export default useOutstandingIncome;
